<template>
  <div
    class="title-container"
    :style="{ marginTop: marginTop, marginBottom: marginBottom }"
  >
    <div class="title_box">
      <img src="../assets/image/all/ic_head_left.png" alt="">
      <span class="allTitle">{{ title }}</span>
      <img src="../assets/image/all/ic_head_right.png" alt="">
    </div>
    <span class="background-text">{{ backgroundText }}</span>
  </div>
</template>

<script>
export default {
  name: "allHead",
  props: {
    title: {
      type: String,
      required: true,
    },
    backgroundText: {
      type: String,
      default: "",
    },
    marginTop: {
      type: String,
      default: "88px",
    },
    marginBottom: {
      type: String,
      default: "34px",
    },
  },
};
</script>

<style scoped>
.title-container {
  display: inline-flex;
  align-items: center;
  padding: 0 10px;
  border-radius: 5px;
  font-family: Arial, sans-serif;
  position: relative;
  /* background: pink; */
}

.allTitle {
  font-weight: bold;
  color: #333;
  position: relative;
  z-index: 1;
  font-size: 32px;
  color: #100926;
  padding: 0 8px;
}

.background-text {
  position: absolute;
  top: -30px;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
  font-size: 32px;
  color: rgba(16, 9, 38, 0.1);
  font-weight: bold;
}

.title_box{
  display: flex;
  align-items: center;

}
</style>